module.exports = __webpack_public_path__ + "img/map_1791458175881_18100.e5ae86c4.jpg";